import { toast } from 'react-toastify';
import type { TFunction } from 'i18next';
import type { VisibilityResult } from 'types/records';

export type VisibilityResultWithName = VisibilityResult & {
  formItemName?: string;
};

/** Empty string is for unnamed form items */
export const getMultipleDefinitionsUniqueNames = (visibilityResults: Record<string, VisibilityResultWithName>): string[] => {
  const multipleUiDefinitionsNames = new Set<string>();
  Object.values(visibilityResults).forEach((result) => {
    if (result.multipleUiDefinitions && result.formItemName) {
      multipleUiDefinitionsNames.add(result.formItemName);
    } else if (result.multipleUiDefinitions) {
      multipleUiDefinitionsNames.add('');
    }
  });
  const multipleUiDefinitionsUniqueNames = [...multipleUiDefinitionsNames];
  return multipleUiDefinitionsUniqueNames;
};

export const multipleDefinitionsToast = (multipleDefinitionsNames: string[], t: TFunction): void => {
  const toastMessageNames = multipleDefinitionsNames
    .filter((formItemName) => formItemName)
    .map((formItemName) => `"${formItemName}"`)
    .join(', ');
  if (toastMessageNames) {
    toast.warning(t('flow.warning.multipleUiDefinitionsWithNames') + toastMessageNames, { style: { whiteSpace: 'pre-line' } });
  } else {
    toast.warning(t('flow.warning.multipleUiDefinitions'));
  }
};
